export {
  RetentionRateAreaChart,
  RetentionRateAreaChartProps,
} from './RetentionRateAreaChart';
